import {Component, inject, input} from "@angular/core";
import {MatIcon} from "@angular/material/icon";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {Translations} from "@translations";
import {DatePipe} from "@angular/common";
import {SessionRunVectorComponent} from "@common/components/session/session-run-vector/session-run-vector.component";
import {SimTimeService} from "../../../../core/services/sim-services/sim-time.service";
import {ChevronOverflowComponent} from "@common/ui/chevron-overflow/chevron-overflow.component";

export interface SessionRunWrapper {
	runId: string;
	startTime: Date;
	durationMinutes: number;
	intermissionDurationMinutes?: number | undefined;
}

@Component({
	selector: "sim-session-run-preview",
	templateUrl: "./session-run-preview.component.html",
	styleUrl: "./session-run-preview.component.scss",
	imports: [MatIcon, TranslateModule, SessionRunVectorComponent, DatePipe, ChevronOverflowComponent],
})
export class SessionRunPreviewComponent {
	readonly translate = inject(TranslateService);
	// I/O
	public runs = input.required<SessionRunWrapper[]>();

	// Constants
	protected readonly T = Translations;

	// Injections
	readonly #timeService = inject(SimTimeService);

	// Derived
	protected readonly timeFormat = this.#timeService.timeFormat;
}
